import React from "react";
import createReactClass from "create-react-class";
import Circle from "./circle";

export default createReactClass({
  displayName: "Root",
  render() {
    const circles = this.props.circles.map(function(circle) {
      return <Circle circle={circle} key={circle.id} />;
    });
    return (
      <div>
        <article className="timeline-box mt20">
          <h2 className="left">
            <i className="far fa-bell icon_blue" aria-hidden="true" />&nbsp;注目のサークル
          </h2>
          <div className="touch-wrap">
            <div className="touch">{circles}</div>
          </div>
        </article>
      </div>
    );
  },
});
